export const PROD_API_BASE_URL = "https://api.health.somnofy.com/";

export const WIPMessageUrl = "https://static.somnofy.com/messages/honu";
